import React, { Component } from 'react';
import style from './DropDownWithLabel.module.css';
// import logoImage from '../assets/images/header_logo.svg';
// import MenuLeft from './MenuLeft.js';
//import artwork from '../assets/images/artwork.svg';

class DropDownWithLabel extends Component {


    renderOption(){
        let item =[];
        let options = this.props.options;

        if(options == undefined || options == null){
            return item;
        }

        if(this.props.placeholder !== "" && this.props.placeholder !== undefined){
            item.push(
                <option key={"none"} value={""}>{this.props.placeholder}</option>
            );
        }
        for(let i=0;i<options.length;i++){
            item.push(
                <option key={options[i].value} value={options[i].value}>{options[i].label}</option>
            );
        }
        //console.log(options);
        return item;
    }





    render() {


        let options =  this.renderOption();

        return (
            <div className={style.area}>
                <div className={style.label}>
                    {this.props.label}
                </div>

                {/* <input type="text" id={this.props.id} onChange={this.props.onChange} value={this.props.value} name={this.props.name}/> */}


                <select name={this.props.name} id={this.props.id} value={this.props.value} onChange={this.props.onChange}>
                    {options}
                </select>






                <div className={style.errorMessage}>
                    {this.props.errorMessage}
                </div>


                {/* <div className={style.inputBox}>
                    <input type="text" onChange={this.props.onChange} value={this.props.value} name={this.props.name}/>
                </div> */}
            </div>
        );
    }
}
export default DropDownWithLabel